import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { Breakdown } from "./Breakdown";
import { Atol, Disclaimers, HiddenFees, Installments } from "./banners";
import {
  type UnifiedPriceBreakdownCheckoutControllerProps,
  useUnifiedPriceBreakdownCheckoutController
} from "./useUnifiedPriceBreakdown.Checkout.controller";

export type UnifiedPriceBreakdownCheckoutProps = UnifiedPriceBreakdownCheckoutControllerProps;

export function UnifiedPriceBreakdownCheckout(props: UnifiedPriceBreakdownCheckoutProps) {
  const { addedItems, isHungaryDepartingRyanAir, disclaimers, unifiedPriceBreakdown, expandedByDefault } =
    useUnifiedPriceBreakdownCheckoutController(props);

  if (!unifiedPriceBreakdown) {
    return null;
  }

  return (
    <Stack gap={4}>
      <Breakdown
        {...unifiedPriceBreakdown}
        addedItems={addedItems}
        isHungaryDepartingRyanAir={isHungaryDepartingRyanAir}
        expandedByDefault={expandedByDefault}
      />
      <Disclaimers disclaimers={disclaimers} />
      <Atol />
      <HiddenFees />
      <Installments />
    </Stack>
  );
}
